import styled from 'styled-components';

export const Container = styled.div`
  padding: 8px 16px;
  margin-right: 24px;

  height: 40px;
  border-radius: 8px;

  border: 1px solid ${({ theme }) => theme.colors.gray[400]};
  background: ${({ theme }) => theme.colors.white};

  position: absolute;
  right: 5px;

  display: flex;
  align-items: center;
  justify-content: center;

  span {
    color: ${({ theme }) => theme.colors.gray[600]};
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }

  .card-value {
    color: ${({ theme }) => theme.colors.primary[30]};
  }
`;
